import { useField } from "formik";
import { useCallback, useMemo } from "react";

export const useAddRemoveThreadProduct = () => {
    const [{ value: products }, , { setValue: setProducts, setError }] =
        useField<any>("product_list");

    //  fast lookup
    const productSet = useMemo(() => {
        return new Set((products ?? []).map((p: any) => p.product_code));
    }, [products]);

    const isAlreadyAdded = (product: any) => {
        return product?.code && productSet.has(product.code);
    };

    const addThreadProducts = useCallback(
        (toAdd: any[]) => {
            const newItems = toAdd
                .filter((d) => !productSet.has(d.code))
                .map((p) => ({
                    product_code: p.code
                }));

            if (newItems.length) {
                setProducts([...(products ?? []), ...newItems]);
            }

            return newItems;
        },
        [products, productSet, setProducts]
    );

    const removeThreadProducts = useCallback(
        (toRemove: { product_code: string }[]) => {
            const removeSet = new Set(toRemove.map((d) => d.product_code));

            setProducts(
                (products ?? []).filter(
                    (p: any) => !removeSet.has(p.product_code)
                )
            );

            setError(undefined);
        },
        [products, setProducts, setError]
    );

    return {
        products,
        isAlreadyAdded, // optional now
        addThreadProducts,
        removeThreadProducts
    };
};